import { X } from 'lucide-react';
import { Dialog as D } from 'radix-ui';
import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import { t } from '@/lib/i18n';
import s from './Dialog.module.css';

export interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  eyebrow?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

/** A modal for short, focused tasks. Things that deserve a URL get a page instead (IA §1.2). */
export function Dialog({ open, onOpenChange, title, description, eyebrow, children, footer, size = 'md' }: DialogProps) {
  return (
    <D.Root open={open} onOpenChange={onOpenChange}>
      <D.Portal>
        <D.Overlay className={s.overlay} />
        <D.Content className={cx(s.content, s[size])}>
          <header className={s.header}>
            <div className={s.heading}>
              {eyebrow && <div className={s.eyebrow}>{eyebrow}</div>}
              <D.Title className={s.title}>{title}</D.Title>
              {description ? (
                <D.Description className={s.description}>{description}</D.Description>
              ) : (
                <D.Description className="sr-only">{title}</D.Description>
              )}
            </div>
            <D.Close className={s.close} aria-label={t('Close')}>
              <X aria-hidden />
            </D.Close>
          </header>
          {children && <div className={s.body}>{children}</div>}
          {footer && <footer className={s.footer}>{footer}</footer>}
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}

export const DialogClose = D.Close;
